import ReactGA from 'react-ga4';

import { config } from '@/environment';

const GA_TRACKING_ID = config.GA_TRACKING_ID;
let isInitialized = false;

export const initGA = () => {
  if (!GA_TRACKING_ID) return;
  ReactGA.initialize(GA_TRACKING_ID);
  ReactGA.gtag('set', 'environment', config.ENVIRONMENT);
  console.log(`GA initialized for environment: ${config.ENVIRONMENT}`);
  isInitialized = true;
};

export const trackPageView = (url: string) => {
  if (!isInitialized) return;
  ReactGA.send({
    hitType: 'pageview',
    page: url,
  });
};

export const trackEvent = (
  category: string,
  action: string,
  label?: string | null,
  value?: number | object | null
) => {
  if (!isInitialized) return;

  const isNumber = typeof value === 'number';

  ReactGA.event({
    category,
    action,
    label: label ?? undefined,
    value: isNumber ? value : undefined, // GA only accepts numbers
    nonInteraction: !isNumber, // avoid GA warnings
    // Store object in label2 (a custom field) if needed
    ...(value && !isNumber ? { customData: JSON.stringify(value) } : {}),
  });
};
